import React, { ReactNode } from "react";
import {
  Box,
  CssBaseline,
  Card,
  CardContent,
} from "@mui/material";
import TitleBar from "./TitleBar";
import Footer from "./Footer";

// Define the props for the Layout component
interface LayoutProps {
  children: ReactNode;
  fullScreen?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, fullScreen = false }) => {
  return (
    <>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Use TitleBar directly - it already has its own AppBar */}
        <TitleBar />
        
        {/* Main content area */}
        <Box 
          sx={{
            marginTop: '64px',
            flexGrow: 1,
            overflowY: 'auto',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            {fullScreen ? (
              children
            ) : (
              <Card sx={{ margin: 2 }}>
                <CardContent>
                  {children}
                </CardContent>
              </Card>
            )}
          </Box>
          
          {/* Footer */}
          <Footer />
        </Box>
      </Box>
    </>
  );
};

export default Layout;
